<template>
  <div class="full-screen">
    <LoadingSpinner v-if="isLoading" />
    <div v-else class="html">
      <iframe :srcdoc="modifiedHTML" />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../components/widgets/LoadingSpinner.vue';

export default {
  name: 'ProcessRunner',
  data() {
    return {
      isLoading: true,
      htmlForm: null,
      customHTML:
        '<style>::-webkit-scrollbar{width:5px;height:5px}::-webkit-scrollbar-track{background:#ffff;border-radius:10px}::-webkit-scrollbar-thumb{background:rgb(117 117 117);border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#555}::-webkit-scrollbar-track{-webkit-box-shadow:none!important;background-color:transparent}::-webkit-scrollbar{width:7px!important;background-color:transparent}::-webkit-scrollbar-thumb{background-color:transparent}</style>',
    };
  },
  props: {
    params: Object,
    id: String,
  },
  methods: {
    getHtmlForm: function () {
      var url = process.env.VUE_APP_FLOW_RUNNER_API;

      url += '/run_flow_by_id';
      url += '?id=' + this.processId;

      let myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      if (this.user) {
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );
      }

      // Use to fill form with url params
      let payload = this.payload;

      fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((response) => response.text())
        .then((html) => {
          this.htmlForm = html;
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.getHtmlForm();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    processId() {
      if (this.id != null) return this.id;
      else return this.$route.params.id;
    },
    payload() {
      if (this.params != null) return this.params;
      else return this.$route.query;
    },
    modifiedHTML() {
      return this.htmlForm + this.customHTML;
    },
  },
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped>
body {
  line-height: 8px;
}

.full-screen {
  width: 100%;
  height: 100%;
}

.full-screen .html {
  width: 100%;
  height: 100%;
}

.full-screen .html iframe {
  width: 100%;
  height: calc(100% - 7px);
}
</style>
